import { render, staticRenderFns } from "./free-coupon-tab.vue?vue&type=template&id=38cb81f9&scoped=true&lang=pug&"
import script from "./free-coupon-tab.vue?vue&type=script&lang=js&"
export * from "./free-coupon-tab.vue?vue&type=script&lang=js&"
import style0 from "./free-coupon-tab.vue?vue&type=style&index=0&id=38cb81f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cb81f9",
  null
  
)

export default component.exports